'use client'

import { AlertDialog } from '@repo/ui/AlertDialog'
import { createConfirmation } from '@repo/ui/ConfirmMountPoint'
import { confirmable } from 'react-confirm'

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
const confirmHOC = confirmable(AlertDialog)
export const alertWithParams = createConfirmation(confirmHOC)

export function alert(message, options = {}) {
  return alertWithParams({ confirmation: message, options })
}
